interface ProductCardProps {
  id: number;
  name: string;
  brand: string;
  price: number;
  rating: number;
  reviews: number;
  description: string;
  image: string;
  badge?: string;
}

export default function ProductCard({
  name,
  brand,
  price,
  rating,
  reviews,
  description,
  image,
  badge,
}: ProductCardProps) {
  return (
    <div className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300" data-product-shop>
      <div className="relative aspect-[4/3] overflow-hidden bg-background-100">
        <img
          src={image}
          alt={name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {badge && (
          <span className="absolute top-3 left-3 bg-primary-500 text-background-50 text-xs font-medium px-2.5 py-1 rounded-full whitespace-nowrap">
            {badge}
          </span>
        )}
      </div>
      <div className="p-4">
        <p className="text-xs text-secondary-500 font-medium mb-1">{brand}</p>
        <h3 className="font-heading text-base font-semibold text-foreground-900 mb-1 line-clamp-1">
          {name}
        </h3>
        <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
          {description}
        </p>
        <div className="flex items-center justify-between">
          <div>
            <span className="text-lg font-bold text-primary-600">&yen;{price}</span>
          </div>
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-xs"></i>
            <span className="text-sm font-medium text-foreground-700">{rating}</span>
            <span className="text-xs text-foreground-400">({reviews.toLocaleString()})</span>
          </div>
        </div>
      </div>
    </div>
  );
}